import React from 'react';
import { UpdatePasswordForm } from '../components';

const ProfileSettings = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Super admin profile settings</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage your account settings and change your password
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="col-span-1 md:col-span-2">
          <UpdatePasswordForm />
        </div>
        <div className="col-span-1 bg-white shadow rounded-lg p-6 h-min">
          <h3 className="text-lg font-medium text-gray-900">Account Info</h3>
          <div className="mt-4 space-y-3">
            <div>
              <div className="text-sm font-medium text-gray-500">Role</div>
              <div className="text-sm text-gray-900">Administrator</div>
            </div>
            <div>
              <div className="text-sm font-medium text-gray-500">Last Login</div>
              <div className="text-sm text-gray-900">{new Date().toLocaleDateString()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings; 